import { RouteType } from "types/RouteType";
import batchPlantDashboardRoute from "./Dashboard/BatchPlantDashboard.Route";
import productionMonitorRoute from "./ProductionMonitor/productionMonitor.Route";
import productionReportRoute from "./ProductionReport/productionReport.Route";
import holdManagementRoute from "./HoldManagement/HoldManagement.Route";
import batchPlantVisualizerRoute from "./BatchPlantVisualizer/BatchPlantVisualizer.Route";
import plantCapacityRoute from "./PlantCapacity/PlantCapacity.Route";
import plantOverviewRoute from "./PlantOverview/PlantOverview.Route";
import mixDesignRoute from "../mixDesign/MixDesign.Route";

const batchPlantRoutesList: RouteType[] = [
  batchPlantDashboardRoute, // Dashboard for batch plant operations
  batchPlantVisualizerRoute, // 3D batch plant visualizer
  plantCapacityRoute, // 2D plant capacity visualization
  plantOverviewRoute, // 2D batch plant equipment overview
  ...productionMonitorRoute, // Real-time batch monitoring
  ...productionReportRoute, // Batch production reports
  holdManagementRoute, // Quality holds for batches
  mixDesignRoute, // Mix design management (simplified from BOM)
];

export default batchPlantRoutesList;
